import React, {useEffect, useState} from "react";
import Home from './UI/pages/home';
import Destination from "./UI/pages/destination";
import Crew from "./UI/pages/crew";
import Technology from "./UI/pages/technology";
import "./styles/App.min.css";
import "./styles/w3.css";
import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import Data from './data.json'

function App() {
  // Introduction()

  // FETCHING DATA
  const [fetchData, setFetchData] = useState({
    descData: [], crewData: [], techData: []
  })
  useEffect(() => {
    setFetchData({
      descData: Data.destinations,
      crewData: Data.crew,
      techData: Data.technology
    })
  }, [])
  
  console.log('APP')

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destination" element={
          <Destination destData={fetchData.descData}/>
        } />
        <Route path="/crew" element={
          <Crew crewData={fetchData.crewData}/>
        } />
        <Route path="/technology" element={
          <Technology techData={fetchData.techData}/>
        } />
      </Routes>
    </BrowserRouter>
  );
}

function Introduction () {
  let isAngel = prompt('Hi... What\'s your name or nickname?')
  let nameString = isAngel ? isAngel.toString().toLowerCase() : ''
  console.log(nameString)
  if (nameString === 'angel' || nameString === 'angle moon' || nameString === 'moon'){
    alert('Love You Angel 💖😇... Please give me some feedback on the site. Critisize it as if you are the owner. Thanks💪')
  } else if (nameString === 'edward' || nameString === 'kayondo' || nameString === 'eddie') {
    alert('Yo... Edward, Wazaaap! Please give some feedback. Thanks😜')
  } else if (nameString === 'zai' || nameString === 'zaienda') {
    alert('Yo... Zai😎, Check this out!')
  } else if (nameString === 'mary' || nameString === 'dinna' || nameString === 'dina') {
    alert('Mary, wanna go to space?😀')
  } else if (nameString === 'allen' || nameString === 'ale' || nameString === 'alle') {
    alert('Allen,😂 how do you feel about going to space?')
  } else if (nameString === '') {
    alert('So No Name!😒 Wazaaap!😒')
  } else {
    let personName = nameString.charAt(0).toUpperCase() + nameString.slice(1,-1)
    alert(`Hi... ${personName}, let me know how the site is?😏`)
  }
  
}
//**== IDEA --- When a main comp has rendered, get the element of class App and change its BG.
//** Animations in react - fadeins, transitions, etc

export default App